module.exports = __webpack_public_path__ + "img/5e7a4df1-db62-4207-95be-d8f41ce17b75.bc3dbdf9.jpg";